import * as React from "react";

export default ({ color = '#221CB6', size = 12 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="6" fill={color} />
    <g clipPath="url(#clip0_29236_2703)">
      <path
        d="M6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7Z"
        fill="white"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.375 5.9987C2.375 5.9987 3.663 3.33203 6 3.33203C8.337 3.33203 9.625 5.9987 9.625 5.9987C9.625 5.9987 8.33667 8.66536 6 8.66536C3.66333 8.66536 2.375 5.9987 2.375 5.9987Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_29236_2703">
        <rect width="8" height="8" fill="white" transform="translate(2 2)"/>
      </clipPath>
    </defs>
  </svg>
);
